import { render } from "./CampaignValidation.vue?vue&type=template&id=d58aa12a&ts=true"
import script from "./CampaignValidation.vue?vue&type=script&lang=ts"
export * from "./CampaignValidation.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__